
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'ChevronDown'
})
export default class ChevronDown extends Vue {}
